import { useEffect, useState } from 'react'
import { useEthers } from '../../hooks'
import { ChainBlacklistedWallets } from './model'
import { CHAIN_ID_NAMES, ChainId, DEFAULT_CHAIN } from '../../constants'

export function useApiBlacklistedWallets() {
  const { chainId = DEFAULT_CHAIN } = useEthers()
  const [blacklistedWallets, setBlacklistedWallets] = useState<ChainBlacklistedWallets>({})

  useEffect(() => {
    let cancelled = false
    ;(async () => {
      if (chainId) {
        try {
          const res = await fetch(
            `https://${
              chainId === ChainId.Kovan ? 'kovan-api' : 'api'
            }.integral.link/api/v1/blacklisted-wallets?network=${CHAIN_ID_NAMES[chainId]}`
          )
          const json = await res.json()
          if (!cancelled) {
            if (json && json.success) {
              const wallets = json.data
              setBlacklistedWallets((blacklistedWallets) => ({
                ...blacklistedWallets,
                [chainId]: wallets,
              }))
            }
          }
        } catch (err) {
          console.error(err)
          if (!cancelled) {
            setBlacklistedWallets((blacklistedWallets) => ({ ...blacklistedWallets, [chainId]: undefined }))
          }
        }
      }
    })()

    return () => {
      cancelled = true
    }
  }, [chainId])

  return chainId && blacklistedWallets[chainId]
}
